import styled from 'styled-components';
import { colors, fontSizes, lineHeights, fontWeights, spacings, responsiveBreakPoints } from '@styles/DesignVariables';
const { maxTablet } = responsiveBreakPoints;

export const HeroStyled = styled.section<{ $bgImage: string }>`
	background-image: linear-gradient(rgba(6, 6, 6, 0.5), rgba(6, 6, 6, 0.5)), url(${(props) => props.$bgImage});
	background-repeat: no-repeat;
	display: flex;
	align-items: center;
	text-align: center;
	justify-content: center;
	flex-direction: column;
	background-size: cover;
	background-position: center;
	margin: 0 0 ${spacings.s20} 0;
	gap: ${spacings.s16};
	width: 100%;
	min-height: 237px;
	@media only screen and ${maxTablet} {
		padding: 10px;
		margin: 0px;
	}
`;

export const HeroHeading = styled.h1`
	color: ${colors.whiteText};
	font-size: ${fontSizes.heroHeading};
	line-height: ${lineHeights.heroHeading};
	font-weight: ${fontWeights.bold};
	@media only screen and ${maxTablet} {
		font-size: ${fontSizes.heroMobileHeading};
		padding: 0 12px;
	}
`;
